<template>
  <div>
    <h1>Quel type de professionnel de santé êtes-vous&nbsp;?</h1>
    <form @submit.prevent="handleSubmit">
      <div class="choices">
        <ButtonGreen :outlined="form.type !== 'doctor'" block @click="setType('doctor')">Médecin</ButtonGreen>
        <ButtonGreen :outlined="form.type !== 'paramedical'" block @click="setType('paramedical')">Paramédical</ButtonGreen>
        <ButtonGreen :outlined="form.type !== 'therapist'" block @click="setType('therapist')">Thérapeute</ButtonGreen>
        <DashedLine />
<!--        <ButtonBlue :outlined="form.type !== 'secretary'" block @click="setType('secretary')">Secrétaire médicale</ButtonBlue>-->
<!--        <DashedLine />-->
        <ButtonBlue :outlined="form.type !== 'nurse'" block @click="setType('nurse')">Infirmier</ButtonBlue>
        <DashedLine />
        <ButtonBlack :link-to="$setting('URL_PATIENT_SIGNUP')" block outlined>Je suis patient</ButtonBlack>
      </div>

      <div v-if="$v.form.type.$dirty" class="error">
        <template v-if="!$v.form.type.required">Veuillez sélectionner un type de professionnel</template>
        <template v-else-if="!$v.form.type.professionalType">Le type est invalide</template>
      </div>

      <SignupButtons :can-be-submitted="!$v.$invalid" />
    </form>
  </div>
</template>

<script>
  import ButtonGreen from '@/components/ButtonGreen';
  import ButtonBlue from '@/components/ButtonBlue';
  import SignupButtons from '@/components/Signup/SignupButtons';
  import DashedLine from '@/components/DashedLine';
  import ButtonBlack from '@/components/ButtonBlack';
  import { required } from '@byscripts/vuelidate/lib/validators';
  import { professionalType } from '@/helpers/validation';

  export default {
    name: 'SignupProfessionalType',
    components: { ButtonBlack, DashedLine, SignupButtons, ButtonGreen, ButtonBlue },
    validations: {
      form: {
        type: {
          required,
          professionalType,
        },
      },
    },
    data() {
      return {
        form: {
          type: this.$store.state.signup.form.type,
        },
      };
    },
    methods: {
      setType(type) {
        this.form.type = this.form.type === type ? null : type;
      },
      handleSubmit() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return this.$addError('Veuillez vérifier le formulaire');
        }

        this.$store.dispatch('signup/saveForm', { form: this.form });
        this.$store.dispatch('signup/goToNextStep');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .choices {
    .base-button {
      margin-bottom: 1rem;
    }

    .dashed-line {
      margin: 3rem 0;
    }
  }
</style>
